export default {
  items: [],
  info: {
    id: 0,
    materialCode: null,
    materialName: null,
    vendorCode: null,
    vendorName: null,
    manufacturerName: null,
    manufacturerAddress: null,
    validMonth: 0,
    remainingMonth: 0,
    isByMonth: true,
    isEnabled: true
  },
  id: null
}
